import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "formatedNumber",
})
export class FormatedNumberPipe implements PipeTransform {
	transform(value: any, args?: any): any {
		return ("0" + value).slice(-2);
	}
}
